// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1LXBl","paymentContainer":"PaymentPage_paymentContainer__b-EgH"};